import { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getStatus } from "@/store/slices/helpers/helpers";
import { clearMultipleData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiUrls } from "@/store/api/constants";

export default function useOnActions() {
  const [isAlertDialog, setIsAlertDialog] = useState(false);

  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const state = useSelector((store) => store);
  const [currentRowId, setCurrentRowId] = useState(null);

  const deleteNotificationSettingsStatus = getStatus(state, 
    apiKeys.deleteNotificationSettingsList, '');

  const onCloseAlert = useCallback(() => {
    setIsAlertDialog((prevState) => !prevState);
    setCurrentRowId(null);
  }, []);

  const onAgreeAlert = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.deleteNotificationSettingsList(currentRowId),
      method: apiMethods.DELETE,
      key: apiKeys.deleteNotificationSettingsList,
      successMsg: formatMessage({ id: "zone-master-has-been-deleted-successfully" }),
      failureMsg: formatMessage({ id: "failed-to-delete-zone-master" }),
    }))
    onCloseAlert();
  }, [dispatch, formatMessage, onCloseAlert, currentRowId]);


  const onRowDelete = useCallback((id) => {
    setCurrentRowId(id);
    setIsAlertDialog(true);
  }, []);



  useEffect(() => () => {
    dispatch(clearMultipleData({ key: apiKeys.deleteNotificationSettingsList }));
  }, [dispatch]);


  return useMemo(() => ({
    onRowDelete,
    deleteNotificationSettingsStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert,

  }), [
    onRowDelete,
    deleteNotificationSettingsStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert,
  ])
}
